
import { z } from 'zod';

export const profileFormSchema = z.object({
  username: z
    .string()
    .min(3, 'Username must be at least 3 characters')
    .max(50, 'Username must be less than 50 characters'),
  full_name: z.string().min(1, 'Full name is required'),
  belt_rank: z.string().min(1, 'Belt rank is required'),
  custom_belt: z.string().optional(),
  stripes: z.string().optional(),
  home_gym: z.string().optional(),
  date_began_training: z.date().optional().nullable(),
  date_achieved_belt: z.date().optional().nullable(),
  belt: z.string().optional(),
  training_preference: z.string().default('Both'),
  email_preferences: z.object({
    weekly_summary: z.boolean(),
    weekly_insights: z.boolean(), // Keep this for backwards compatibility
    last_updated: z.string().optional()
  })
});

export type ProfileFormValues = z.infer<typeof profileFormSchema>;
